import FacebookIcon from "@assets/icons/facebook.svg";
import TwitterIcon from "@assets/icons/twitter.svg";
import { LineAuthButton } from "features/shared/components/LineAuthButton";
import { signIn } from "next-auth/client";
import { useState } from "react";
import { Button } from "shared/components/atoms/Button";
import { useHostName } from "shared/hooks/useHostName";
import tw from "twin.macro";
import { Paths } from "utils/routes";

const provider = {
  line: "line",
  twitter: "twitter",
  facebook: "facebook",
} as const;

const styles = {
  icon: tw`mr-2 svg text-white`,
  halfSnsButtonLabel: tw`w-40 font-medium text-left text-[11px] leading-4`,
};

export const SocialLogin = () => {
  const [disabled, setDisabled] = useState(false);

  const { host } = useHostName();

  const handleLogin = (social: typeof provider[keyof typeof provider]) => {
    setDisabled(true);
    signIn(social, {
      callbackUrl: `${host}${Paths.callbacks[social].default().pathname}`,
    });
  };

  return (
    <>
      <LineAuthButton tw="w-80">LINEで登録・ログインする</LineAuthButton>
      <div tw="flex my-4 mb-9">
        <Button
          tw="bg-twitter mr-1"
          css={styles.halfSnsButtonLabel}
          onClick={() => handleLogin(provider.twitter)}
          disabled={disabled}
        >
          <TwitterIcon css={styles.icon} />
          Twitterで
          <br />
          登録・ログイン
        </Button>
        <Button
          tw="bg-facebook"
          css={styles.halfSnsButtonLabel}
          onClick={() => handleLogin(provider.facebook)}
          disabled={disabled}
        >
          <FacebookIcon css={styles.icon} />
          Facebookで
          <br />
          登録・ログイン
        </Button>
      </div>
    </>
  );
};
